<template>
    <div class="missing-venue-profile-fields-modal-container">
        <p class="title">Complete your venue profile</p>
        <p class="subtitle">
            You can not create Hedlyner opportunities and invite artists, until you fill in the
            following fields in your profile:
        </p>
        <ul class="profile-required-list">
            <li v-for="(field, indx) in requiredProfileFields" :key="indx">
                {{ field }}
            </li>
        </ul>
        <button @click="$emit('close-missing-fields-modal')" class="confirm-btn">
            I got it
        </button>
    </div>
</template>
<script>
    export default {
        name: 'MissingVenueProfileFieldsModal',
        emits: ['close-missing-fields-modal'],
        props: {
            requiredProfileFields: {
                required: true,
                type: Array
            }
        }
    }
</script>
<style lang="scss" scoped>
    $mobileMax: 600px;
    @media screen and (max-width: $mobileMax) {
        .missing-venue-profile-fields-modal-container {
            padding: 48px 16px !important;

            .title {
                font-size: 32px !important;
            }
        }
    }
    p {
        margin-bottom: 0px;
    }
    button {
        border: none;
    }

    .missing-venue-profile-fields-modal-container {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        gap: 16px;
        padding: 48px 80px;
        border-radius: 15px;
        background: #262626;
        max-width: 745px;

        .title {
            color: #f5f5f5;
            font-family: Instrument Sans;
            font-size: 44px;
            font-style: normal;
            font-weight: 500;
            line-height: 110%;
            letter-spacing: -1.76px;
        }
        .subtitle {
            color: #acacac;
            font-family: Instrument Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 650;
            line-height: 120%;
            margin-left: 22px;
        }
        .profile-required-list {
            list-style: none;
            margin-right: auto;

            li::before {
                content: '\25AA';
                color: #acacac;
                display: inline-block;
                width: 1em;
                margin-left: -2em;
            }
            li {
                color: #acacac;
                font-family: Instrument Sans;
                font-size: 18px;
                font-style: normal;
                font-weight: 650;
                line-height: 120%;
            }
        }
        .confirm-btn {
            margin-top: 32px;
            border-radius: 100px;
            background: #cdeb09;
            padding: 11px 30px 12px 30px;
            color: black;
            font-family: Instrument Sans;
            font-size: 18px;
            font-style: normal;
            font-weight: 650;
            line-height: 120%;
        }
    }
</style>
